import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MfaPolicyDto } from '../interfaces/mfa-policy-dto';
import { TrustedDevicePurgeJob } from '../interfaces/trusted-device-purge-job';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class MfaPolicyService {
    private readonly http = inject(HttpClient);
    private env = inject(envToken);

    getMfaPolicyUrl = '';
    saveMfaPolicyUrl = '';
    trustedDevicePurgeUrl = '';

    constructor() {
        this.getMfaPolicyUrl = this.env.apiUrl + '/api/v1/mfa-policy/enterprise/';
        this.saveMfaPolicyUrl = this.env.apiUrl + '/api/v1/policy/mfa/enterprise/';
        this.trustedDevicePurgeUrl = this.env.apiUrl + '/api/v1/trusted-device-purge/enterprise/';
    }

    getMfaPolicy(enterpriseId: number): Observable<MfaPolicyDto> {
        return this.http.get<MfaPolicyDto>(`${this.getMfaPolicyUrl}${enterpriseId}`);
    }

    saveMfaPolicy(enterpriseId: number, emailDomainPolicy: MfaPolicyDto) {
        return this.http.post(`${this.saveMfaPolicyUrl}${enterpriseId}`, emailDomainPolicy);
    }

    /** Latest trusted-device purge outcome for the enterprise (null body when none recorded yet). Used to poll for completion after a device-trust change. */
    getLatestTrustedDevicePurge(enterpriseId: number): Observable<TrustedDevicePurgeJob | null> {
        return this.http.get<TrustedDevicePurgeJob | null>(`${this.trustedDevicePurgeUrl}${enterpriseId}/latest`);
    }
}
